import { render, staticRenderFns } from "./show-large-tile.vue?vue&type=template&id=67d69aa2"
import script from "./show-large-tile.vue?vue&type=script&lang=js"
export * from "./show-large-tile.vue?vue&type=script&lang=js"
import style0 from "./show-large-tile.vue?vue&type=style&index=0&id=67d69aa2&prod&lang=scss&module=true"




function injectStyles (context) {
  
  this["$style"] = (style0.locals || style0)

}

/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  null,
  null
  
)

export default component.exports